import React from 'react';
import { useTranslation } from 'react-i18next';

/* Inline SVG icons — lightweight, no extra dependency */
const XIcon = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const LinkedInIcon = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
);

const SOCIAL_LINKS = [
    { icon: XIcon, href: 'https://x.com/humanreplica_ai', label: 'X' },
    { icon: LinkedInIcon, href: 'https://linkedin.com/company/humanreplica-ai', label: 'LinkedIn' },
];

const WaitlistFooter: React.FC = () => {
    const { t } = useTranslation('marketing');

    return (
        <footer className="relative z-10 border-t border-hig-border py-12 md:py-16">
            <div className="container-hig">
                <div className="max-w-xl mx-auto text-center space-y-5">
                    {/* Brand */}
                    <p className="text-base font-semibold text-hig-text-primary tracking-tight">
                        HumanReplica.ai®
                    </p>

                    {/* Tagline */}
                    <p className="text-sm text-hig-text-tertiary leading-relaxed">
                        {t('waitlist.footer_tagline')}
                    </p>

                    {/* Social links */}
                    <div className="flex justify-center gap-4 pt-1">
                        {SOCIAL_LINKS.map(({ icon: Icon, href, label }) => (
                            <a
                                key={label}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={label}
                                className="text-hig-text-tertiary hover:text-hig-text-secondary transition-colors duration-200"
                            >
                                <Icon />
                            </a>
                        ))}
                    </div>

                    {/* Trust inline */}
                    <p className="text-[11px] uppercase tracking-[0.15em] text-hig-text-tertiary">
                        {t('waitlist.trust_gdpr')} · {t('waitlist.trust_human_command')}
                    </p>

                    {/* Copyright */}
                    <p className="text-xs text-hig-text-tertiary">
                        © 2026 HumanReplica.ai®
                    </p>

                    {/* Human line */}
                    <p className="text-xs text-hig-text-tertiary italic leading-relaxed">
                        {t('waitlist.footer_human_line')}
                    </p>

                    {/* Legal links */}
                    <div className="flex justify-center gap-6 pt-2">
                        <a
                            href="/whitepaper"
                            className="text-[11px] text-hig-text-tertiary hover:text-hig-text-tertiary transition-colors underline underline-offset-2"
                        >
                            {t('whitepaper.header_link', 'Whitepaper')}
                        </a>
                        <a
                            href="/privacy"
                            className="text-[11px] text-hig-text-tertiary hover:text-hig-text-tertiary transition-colors underline underline-offset-2"
                        >
                            {t('footer.privacy_policy')}
                        </a>

                    </div>
                </div>
            </div>
        </footer>
    );
};

export default WaitlistFooter;
